import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {PAGES_ROUTE} from './pages.routing';
import {SharedModule} from '../shared/shared.module';
import {ComponentsModule} from '../components/components.module';
import {LayoutModule} from '../layouts/layout.module';

import {
  AuthorsTabComponent,
  BlogComponent,
  CategoriesListComponent,
  CategoryFormComponent,
  CollectionContentComponent,
  ContentTableComponent,
  CoverageComponent,
  CoverageTabComponent,
  CreateProjectComponent,
  DashboardFacetsComponent,
  DashboardFacetsSkeletonComponent,
  DashboardFacetsSortComponent,
  DashboardFacetsTableComponent,
  EditUserComponent,
  FacetAuthorContentComponent,
  FacetCompanyContentComponent,
  FacetOutletContentComponent,
  FacetProductContentComponent,
  FacetsSkeletonComponent,
  FacetsSortComponent,
  FacetsTableComponent,
  FacetTopicContentComponent,
  MiniTopicsTableComponent,
  MyAccountComponent,
  MyCoverageReportingComponent,
  MyOrganizationComponent,
  NewsFeedComponent,
  NewUserComponent,
  OffCanvasComponent,
  OutletManagerComponent,
  OutletsTabComponent,
  PagesComponent,
  PaymetSuccessfulComponent,
  RelevancebarChartComponent,
  ReportMissingIncorrectDataComponent,
  SelectProjectComponent,
  ShortTermChartComponent,
  SidebarAuthorManagerComponent,
  SidebarCompanyManagerComponent,
  SidebarContentItemsManagerComponent,
  SidebarTopicManagerComponent,
  SignUpComponent,
  StepOneComponent,
  StepTwoComponent,
  TopicsComponent,
  TopicsRankedListComponent,
  TopicsRankedSkeletonComponent,
  TrendNegativebarChartComponent,
  UserAvatarComponent,
  UserFormComponent,
  UsersListComponent,
  WelcomeComponent,
} from './index';
import {AlertSettingsComponent} from './topics/project/alert-settings/alert-settings.component';
import {EditProjectComponent} from './topics/project/edit-project/edit-project.component';
import { TransferProjectComponent } from './topics/project/transfer-project/transfer-project.component';
import {ProjectLogoComponent} from './topics/project/edit-project/project-logo/project-logo.component';

@NgModule({
  exports: [PagesComponent],
  imports: [
    LayoutModule,
    SharedModule,
    PAGES_ROUTE,
    BrowserModule,
    BrowserAnimationsModule,
    ComponentsModule,
  ],
  declarations: [
    PagesComponent,
    TopicsComponent,
    SidebarTopicManagerComponent,
    CoverageComponent,
    OffCanvasComponent,
    DashboardFacetsComponent,
    DashboardFacetsTableComponent,
    FacetAuthorContentComponent,
    FacetOutletContentComponent,
    FacetCompanyContentComponent,
    FacetTopicContentComponent,
    DashboardFacetsSkeletonComponent,
    DashboardFacetsSortComponent,
    TopicsRankedListComponent,
    TopicsRankedSkeletonComponent,
    MiniTopicsTableComponent,
    ShortTermChartComponent,
    RelevancebarChartComponent,
    TrendNegativebarChartComponent,
    SidebarCompanyManagerComponent,
    SidebarAuthorManagerComponent,
    OutletManagerComponent,
    FacetProductContentComponent,
    SelectProjectComponent,
    CreateProjectComponent,
    AlertSettingsComponent,
    EditProjectComponent,
    TransferProjectComponent,
    ProjectLogoComponent,
    CategoriesListComponent,
    CategoryFormComponent,
    ReportMissingIncorrectDataComponent,
    SignUpComponent,
    PaymetSuccessfulComponent,
    FacetsTableComponent,
    ContentTableComponent,
    FacetsSortComponent,
    FacetsSkeletonComponent,
    NewsFeedComponent,
    WelcomeComponent,
    StepOneComponent,
    StepTwoComponent,
    MyAccountComponent,
    MyOrganizationComponent,
    UsersListComponent,
    UserAvatarComponent,
    UserFormComponent,
    NewUserComponent,
    EditUserComponent,
    CollectionContentComponent,
    BlogComponent,
    MyCoverageReportingComponent,
    SidebarContentItemsManagerComponent,
    CoverageTabComponent,
    AuthorsTabComponent,
    OutletsTabComponent,
    ],
})
export class PagesModule {}
